import axios from "axios";
import { mapSizesToProducts } from "../../../src/utils/mapSizesToProduct";
import { useRouter } from "next/router";
import { parse } from "cookie";
import { getLocationDetail } from "../../../api.services.js/catalouge";
import SubCategory from "../../../src/components/sub-category";
import client from "../../../graphqlClient";
import { getProductQueryServerSide } from ".";
import { categoryValues } from "../category.json";
import { tile_size } from "../../../src/constants";

export async function getServerSideProps({ query, params, req, resolvedUrl }) {
  let size, // size value of the tile;
    sizeName, // size name of the tile;
    type, // type of the tile;
    isSize = false, // size in query exists
    props = {};

  const cat = "Living Room Tiles", // category for breadcrumbs
    subCat = query.subCategory.join("/"); // subcategory for breadcrumbs

  props.oldComponentProps = { ...props.oldComponentProps, cat, subCat };

  let { subCategory } = params;
  let unBxdProd, facetsUnbxd, appliedFilterFromUnbxd;
  let CategoryIdFromCategoryJson;

  // parse cookies
  const cookies = parse(req.headers.cookie || "");
  try {
    if (subCategory) size = subCategory[0];

    // get the category Id from the category values
    categoryValues.forEach((el) => {
      if (
        el.urlKey === `tiles/living-room-tiles/${query.subCategory.join("/")}`
      ) {
        CategoryIdFromCategoryJson = el.id;
      }
    });

    //convert size name to size value
    tile_size.forEach(({ tileValue, tileName }) => {
      if (tileName === size) {
        size = tileValue;
        isSize = true;
        sizeName = tileName;
        props.oldComponentProps = {
          ...props.oldComponentProps,
          isSize,
        };
      }
    });

    let newQuery = { ...query, tile_size: size };

    subCategory.includes("walls-tiles") ? (type = "wall") : (type = "floor");

    // proxy server

    let filter = {},
      magentoFilter = {};

    const errorArray = [
      "cat",
      "remc",
      "product_list_order",
      "product_list_dir",
      "mt",
      "trending",
      "tile_finish",
      "aor",
      "tiles_design",
      "tile_color",
      "p",
      "locations",
      ";popularity",
      "application",
      "type_finish",
      "plocation",
      ";trending",
      ";mt",
      "tiles_type",
      "finish",
      "limit",
      "available_region",
    ];

    // check if query params are present
    // if yes, then add them to the filter object
    for (let f of Object.keys(query)) {
      if (f && query[f]) {
        if (
          f != "subCategory" &&
          !isNaN(query[f].split(",")[0]) &&
          !errorArray.includes(f)
        ) {
          filter = {
            ...filter,
            [f]: {
              $in: query[f].split(",").map((cur) => Number(cur)),
            },
          };
          magentoFilter = {
            ...magentoFilter,
            [f]: {
              in: query[f].split(",").map((cur) => Number(cur)),
            },
          };
        }
      }
    }

    filter = {
      ...filter,
      tile_size: { $in: [Number(size)] },
    };

    if (cookies?.pincode) {
      props = { ...props, fromPincode: true };

      const [resp, locationDetail] = await Promise.all([
        axios.post(
          `https://obl-js.orientbell.com/api/products?category=107&pincode=${cookies.pincode}`,
          filter
        ),
        getLocationDetail({
          pincode: cookies.pincode,
        }),
      ]);

      if (locationDetail?.data?.p_location) {
        magentoFilter.plocation = {
          in: [locationDetail.data.p_location.value],
        };
      }

      props.oldComponentProps = {
        ...props.oldComponentProps,
        fromPincode: true,
        ProdBySalesDate: resp.data || [],
        appliedFilters: filter,
        value: 107,
        displayLocationPopop: true,
        categoryValue: resolvedUrl.split("?")[0],
        regionData: locationDetail?.data?.p_location || null,
        fitterrss: filter,
        fitterrss2: filter,
        UnbxdResponse: { numberOfProducts: 0, products: [] },
        facetsUnbxd: {},
        appliedFilterFromUnbxd: {},
      };
    } else {
      // no pincode -> Unbxd branch
      const queryParamsArray = Object.keys(newQuery)
        .filter((k) => k !== "subCategory")
        .map((k) => ({
          [k]: isNaN(newQuery[k]) ? newQuery[k] : Number(newQuery[k]),
        }));

      const baseUrl = `https://search.unbxd.io/efff4c80403c9e5356384bd354272ff4/ss-unbxd-aapac-dev-orientbell53741713874300/category`;
      const pId = `p-id=categoryPathId%3A%22${encodeURIComponent(
        resolvedUrl.split("?")[0]
      )}%22`;
      const extras = `&facet.multiselect=true&spellcheck=true&pagetype=boolean&rows=25&start=0&version=V2&fallback=true&viewType=GRID&facet.version=V2`;
      // console.log(`${baseUrl}?${pId}${extras}`);
      unBxdProd = await axios.get(`${baseUrl}?${pId}${extras}`);

      facetsUnbxd = unBxdProd.data.facets || null;
      appliedFilterFromUnbxd = queryParamsArray.length
        ? queryParamsArray
        : null;

      props.oldComponentProps = {
        ...props.oldComponentProps,
        url: baseUrl,
        fromPincode: false,
        UnbxdResponse: unBxdProd.data.response,
        appliedFilters: appliedFilterFromUnbxd,
        facetsUnbxd,
        displayLocationPopop: true,
        appliedFilterFromUnbxd,
        categoryValue: resolvedUrl.split("?")[0],
      };
    }

    const gqlRes = await client.query({
      query: getProductQueryServerSide,
      variables: {
        filter: {
          category_id: { in: [CategoryIdFromCategoryJson] },
          ...magentoFilter,
        },
        sort: { recommended: "ASC" },
        pageSize: props.fromPincode ? 14 : 15,
        currentPage: 1,
      },
    });

    if (query.subCategory.includes("floor-tiles")) {
      // Manupulation for url with floor tiles to show the correct data
      let tempData = {
        ...gqlRes.data,
        products: {
          ...gqlRes.data.products,
          currentcategory: {
            ...gqlRes.data.products.currentcategory,
            meta_title: `Living Room ${sizeName} Floor Tiles`,
            meta_description: `Explore Living Room ${sizeName} Floor Tiles`,
            description: "",
            dynamic_content: "",
          },
        },
      };

      gqlRes.data = tempData;
    }

    props.oldComponentProps.data = gqlRes.data;
  } catch (error) {
    console.log(error);
    props = { error: error.message };
  }

  return { props };
}
export default function component(props) {
  if (props.error) {
    return <div>{JSON.stringify(props.error)}</div>;
  }

  return <SubCategory {...props.oldComponentProps} />;
}
